import { Card } from "../components/Card";
import { Disclaimer } from "../components/Disclaimer";
import { PageHeader } from "../components/PageHeader";
import { reportTemplates } from "../lib/constants";

export function Reports() {
  return (
    <>
      <PageHeader
        eyebrow="التقارير"
        title="قوالب تقارير فنية وتأمينية قابلة للطباعة"
        description="تركز التقارير على الحالة الفنية، الضرر محل الفحص، تكلفة الإصلاح، والتوصيات، دون تقديم تقييم للقيمة السوقية."
      />
      <section className="py-20">
        <div className="container grid gap-4 md:grid-cols-3">
          {reportTemplates.map((report) => (
            <Card key={report.title}>
              <h2 className="text-xl font-bold text-charcoal">{report.title}</h2>
              <p className="mt-3 leading-8 text-ash">{report.description}</p>
            </Card>
          ))}
        </div>
      </section>
      <section className="bg-sand py-12">
        <div className="container">
          <Disclaimer />
        </div>
      </section>
    </>
  );
}
